// for add employee

export const RESET_UPLOAD_LOGO = "reset_UPLOAD_LOGO";
export const UPLOAD_LOGO = "UPLOAD_LOGO";
export const UPLOAD_LOGO_SUCCESS = "UPLOAD_LOGO_success";
export const UPLOAD_LOGO_FAILURE = "UPLOAD_LOGO_failure";
